// @flow

export const phonePrettyRepr = (v: mixed): string => {
	if (!v || typeof v !== 'string') {
		return '';
	}

	const match = /^(\d?)(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(v.replace(/\D/g, ''));

	if (!match) {
		return v;
	}

	const [ /*ignored*/, optionalCode, triple1, triple2, pair1, pair2 ] = match;

	const code = optionalCode || '7';

	return `+${code} (${triple1}) ${triple2}-${pair1}-${pair2}`;
};

export const phonePrettyReprExtend = { repr: {
	prettyPhone: phonePrettyRepr,
	default: phonePrettyRepr,
} };
